import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row"
    },
    content: {
        justifyContent: "center",
        flexDirection: "column",
        flexWrap: "wrap"
    },
    avatarImage: {
        borderWidth: 0
    },
    companyText: {
        marginTop: 2
    }
});
export default stylesheet;
